// src/app/employee-timesheets/utils/date-utils.ts

import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.extend(isoWeek);
dayjs.extend(weekOfYear);

export interface WeekInfo {
  year: number;
  week: number;
  yyyyww: string; // e.g., "202603"
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
}

export class DateUtils {
  /**
   * Get the current week
   */
  static getCurrentWeek(): WeekInfo {
    const now = dayjs();
    return DateUtils.formatWeek(now.isoWeekYear(), now.isoWeek());
  }

  /**
   * Get the next week relative to a WeekInfo
   */
  static getNextWeek(current: WeekInfo): WeekInfo {
    const nextWeekDate = current.startDate.add(1, 'week');
    return DateUtils.formatWeek(nextWeekDate.isoWeekYear(), nextWeekDate.isoWeek());
  }

  /**
   * Get the previous week relative to a WeekInfo
   */
  static getPreviousWeek(current: WeekInfo): WeekInfo {
    const prevWeekDate = current.startDate.subtract(1, 'week');
    return DateUtils.formatWeek(prevWeekDate.isoWeekYear(), prevWeekDate.isoWeek());
  }

  /**
   * Format year + week into WeekInfo
   */
  private static formatWeek(year: number, week: number): WeekInfo {
    const startDate = dayjs().year(year).isoWeek(week).startOf('isoWeek');
    const endDate = startDate.endOf('isoWeek');
    const yyyyww = `${year}${week.toString().padStart(2, '0')}`;
    return { year, week, yyyyww, startDate, endDate };
  }
}
